import React from 'react'

const TimelinePaginationContext = React.createContext(null)

export const PAGE_SIZE = 20

const TimelinePaginationProvider = ({ children }) => {
  const cache = React.useRef(new Map())

  const initialize = React.useCallback((id, method, next, extra) => {
    cache.current.set(id, { method, next, extra })
  }, [])

  const getData = React.useCallback(async id => {
    const map = cache.current
    if (!map.has(id)) {
      return { data: [], extra: null }
    }

    const { method, next, extra } = map.get(id)
    if (!next) {
      return { data: [], extra }
    }

    const { data, next: newNext } = await method(id, PAGE_SIZE, next)
    map.set(id, { method, next: newNext, extra })
    return { data, extra: { ...extra, next } }
  }, [])

  const isDoneLoading = React.useCallback(id => {
    const map = cache.current
    if (!map.has(id)) {
      return true
    }

    const { next } = map.get(id)
    return !Boolean(next)
  }, [])

  return (
    <TimelinePaginationContext.Provider
      value={{ initialize, getData, isDoneLoading }}
    >
      {children}
    </TimelinePaginationContext.Provider>
  )
}

export default TimelinePaginationProvider

export const useTimelinePagination = () =>
  React.useContext(TimelinePaginationContext)
